import { useEffect, useState } from 'react';
import { allowModalScroll, preventModalScroll } from '../../common/utils';

function HubImagePreviewModal(props) {
	const [ImageData, setImageData] = useState('');

	useEffect(() => {
		setImageData(props.imageData);
		const prevScrollY = preventModalScroll();
		return () => {
			allowModalScroll(prevScrollY); //컴포넌트가 언마운트되거나 업데이트될 때 이 함수가 실행
		};
	}, []);

	return (
		<div className='modal'>
			<div className='overlay' onClick={() => props.getHubImagePreviewModalOpen(false)}></div>
			<div className='imagePreviewPopup-content'>
				<div className='modal-header'>
					<span className='imagePreview-header-text'>이미지 미리보기</span>
				</div>
				<button
					className='close-modal'
					onClick={() => props.getHubImagePreviewModalOpen(false)}
				></button>
				<div className='modal-body'>
					<p
						dangerouslySetInnerHTML={{
							__html: ImageData.replace(
								/<div/g,
								'<div style="max-width:100%; display:flex; flex-direction:column;"'
							),
						}}
					></p>
				</div>
			</div>
		</div>
	);
}

export default HubImagePreviewModal;
